import {
  Select,
  MenuItem,
  IconButton,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import {Clear} from "@material-ui/icons";
import React from "react";

type valueType = string;

interface InlineMultiSelectProps {
  label: string;
  value: valueType[];
  menuItems: Array<{value: valueType; label: string}>;
  updator: (value: valueType[]) => void;
}

export default function InlineMultiSelect({
  label,
  menuItems,
  value,
  updator,
}: InlineMultiSelectProps) {
  return (
    <span
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        minWidth: "10em",
      }}
    >
      <FormControl fullWidth>
        <InputLabel id="label">{label}</InputLabel>
        <Select
          labelId="label"
          value={value}
          onChange={({target}) => updator(target.value as valueType[])}
          label="Value"
          multiple
        >
          {menuItems.map(({value, label}, key) => (
            <MenuItem key={key} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {value?.length > 0 && (
        <IconButton size="small" onClick={() => updator([])}>
          <Clear />
        </IconButton>
      )}
    </span>
  );
}
